import React, { Component } from 'react';
import { StyleSheet, css} from 'aphrodite';
import BioText from './bioText';
import Transition from 'react-transition-group/Transition';

class Bio extends Component {
  state={
    in: false
  }

  componentDidMount() {
    this.setState({in: true});
  }

  render() {
    const defaultStyle = {
      transition: 'opacity 750ms ease-in-out',
      opacity: 0,
    }
    const transitionStyles = {
        entering: { opacity: 0 },
        entered: { opacity: 1 }
    }
    return(
      <Transition in={this.state.in} timeout={500}>
        {
          (state) => {
            return (
              <div className="row" style={{...defaultStyle, ...transitionStyles[state]}}>
                <div className={`col-md-12 ${css(styles.bioContainer)}`}>
                  <img src="https://res.cloudinary.com/momojunzi/image/upload/v1537999690/portfolio/profile2.jpg" 
                      className={`img-fluid float-left rounded ${css(styles.image)}`} 
                  /> 
                  <BioText />
                </div>
              </div>
            )
          }
        }
        
      </Transition>
    )
  }
}
//
const styles = StyleSheet.create({
  image: {
    marginRight: '1.5vw',
    maxWidth: '40%'
  },
  bioContainer: {
    background: 'rgba(43,43,47, 0.75)',
    padding: '2.5vh 1.5vw 2.5vh 1.5vw',
    '@media (max-width: 767px)': {
      paddingRight: '3vw',
      paddingLeft: '3vw'
    }
  },
  
});


export default Bio



// WEBPACK FOOTER //
// ./src/components/bio/bio.js